// 새 문구는 3개만 둔다. 제목·버튼·완료 안내는 기존 메시지를 다시 쓴다.
export const chartFrameLoginMessages = {
    title: ['M0327', '로그인 해주세요.'],
    signedIn: ['M0108', '로그인 되었습니다.'],
    description: [
        'text.0199',
        '새 창에서 로그인하면 이 화면이 자동으로 다시 열립니다.',
    ],
    login: ['ui.button.login', '로그인'],
    blocked: [
        'text.0200',
        '로그인 창이 열리지 않았습니다. 브라우저에서 팝업을 허용한 후 다시 시도해 주세요.',
    ],
    // 창이 닫혔을 때와 로그인 상태 확인이 실패했을 때 같은 안내를 쓴다.
    notConfirmed: [
        'text.0201',
        '로그인을 확인하지 못했습니다. 다시 시도해 주세요.',
    ],
    retry: ['word.retry', '다시 시도'],
    cancel: ['ui.button.cancel', '취소'],
} as const;
